import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material';

export interface ResourceFolderIconStyles {
  color: string;
}

export const useStyles = makeStyles<Theme, ResourceFolderIconStyles>({
  backdrop: {
    filter: 'brightness(0.7)',
  },
  containerNumber: {
    position: 'relative',
  },
  number: {
    color: ({ color }) => color,
    fontSize: 12,
    fontFamily: 'Roboto-Bold,Roboto',
    fontWeight: 700,
    letterSpacing: '.01em',
    filter: 'brightness(0.7)',
    position: 'absolute',
    right: 53,
    bottom: 9,
  },
});
